import * as React from "react";
const SvgFiRrSirenOn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-siren-on_svg__a)">
      <path
        fill="#062147"
        d="m20.71 18.063-.775-7.761A4.76 4.76 0 0 0 15.18 6H8.82a4.763 4.763 0 0 0-4.754 4.302l-.776 7.76A4.006 4.006 0 0 0 0 22c0 1.103.898 2 2 2h20c1.104 0 2-.897 2-2 0-1.963-1.422-3.6-3.29-3.937M6.057 10.5A2.77 2.77 0 0 1 8.82 8h6.36a2.77 2.77 0 0 1 2.765 2.5l.75 7.5H5.305zM2 22c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2zM20.797 6.21a1 1 0 0 1-.008-1.413l1.5-1.517a1 1 0 1 1 1.422 1.406l-1.5 1.517a.996.996 0 0 1-1.414.008M16.47 2.316 17.39.54a1 1 0 1 1 1.775.92l-.92 1.776a1 1 0 1 1-1.775-.921M.289 4.687A1 1 0 1 1 1.71 3.28l1.5 1.517a1 1 0 1 1-1.422 1.406zM4.834 1.46A1 1 0 0 1 6.609.539l.92 1.775a1 1 0 1 1-1.775.92l-.92-1.775m2.99 11.44.2-2a1 1 0 0 1 .996-.9h1.979a1 1 0 0 1 0 2H9.924l-.11 1.1a1 1 0 1 1-1.991-.2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-siren-on_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSirenOn;
